import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  config: {
    hide: false
  }
};

export const navConfigSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    hideNav: (state, action: PayloadAction<boolean>) => {
      state.config.hide = action.payload;
    },
  },
});

export const { hideNav } = navConfigSlice.actions;

export default navConfigSlice.reducer;
